import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  Box,
  Grid,
  TextField,
  FormHelperText
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import AddCustomerModal from 'components/SalesOrders/AddCustomerModal';

const filter = createFilterOptions();

const CustomerDueDate = (props) => {
  
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [focusedInput, setFocusedInput] = useState();
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [phoneBuffer, setPhoneBuffer] = useState("");

  useEffect(() => {
    if(props.startDate && props.endDate) {
      setStartDate(moment(props.startDate));
      setEndDate(moment(props.endDate));
    }
  }, [props.customerId, props.customers, props.startDate, props.endDate]);

  const customerInput = useMemo(() => {
    if(props.customerId > 0) {
      const customerInfo = props.customers.find(customer => customer.id === props.customerId);
      const firstLetter = customerInfo.name[0].toUpperCase();
      return({firstLetter, id: customerInfo.id, name: customerInfo.name, phone: customerInfo.phone});
    }
    else return null;

  }, [props.customerId, props.customers]);

  const customersObj = useMemo(() => (
    props.customers
      .map(customer => {
        const firstLetter = customer.name[0].toUpperCase();
        return {firstLetter, id: customer.id, name: customer.name, phone: customer.phone}
      })
      .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))
  
  ), [props.customers]);

  const onDatesChange = ({startDate, endDate}) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if(startDate && endDate) {
      props.setNewSODate({
        startDate: startDate,
        endDate: endDate
      });
    }
  };

  const handleCustomerModalClose = () => {
    setOpenCustomerModal(false);
    setPhoneBuffer("");
  };

  const createCustomerDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.user.adminId).body.customer;
    let customerNum;
    length < 100 ? 
      customerNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : customerNum = length
    return ("C-" + customerNum);
  };

  return (
    <React.Fragment>
      <Box marginTop={3}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <Autocomplete
              onChange={(event, newValue) => {
                if (newValue && newValue.inputValue) {
                  setOpenCustomerModal(true);
                  setPhoneBuffer(newValue.inputValue);
                } 
                else {
                  if(newValue) props.setNewSOCustomerId(newValue.id);
                  else props.setNewSOCustomerId(0);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                if (params.inputValue !== '') {
                  filtered.push({
                    inputValue: params.inputValue,
                    name: "Add customer -",
                    phone: params.inputValue
                  });
                }

                return filtered;
              }}
              id="free-solo-dialog-demo"
              fullWidth
              options={customersObj}
              groupBy={(customer) => customer.firstLetter}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => `${option.name} (${option.phone})`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Customer.."
                  variant="outlined"
                />
              )}
              value={customerInput}
            />
            <FormHelperText>Please Select a Customer</FormHelperText>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            style={{textAlign: "center"}}
          >
            <DateRangePicker
              block
              startDateId="123456" // PropTypes.string.isRequired,
              endDateId="567890" // PropTypes.string.isRequired,
              startDate={startDate} // momentPropTypes.momentObj or null,
              endDate={endDate} // momentPropTypes.momentObj or null,
              isOutsideRange={() => false}
              displayFormat="DD/MM/YYYY"
              onDatesChange={onDatesChange} // PropTypes.func.isRequired,
              focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
            />
            <FormHelperText>Pick the Due Date of the Sale</FormHelperText>
          </Grid>
        </Grid>
      </Box>
      { openCustomerModal ?
      <AddCustomerModal
        open={openCustomerModal}
        user={props.user}
        closeModal={handleCustomerModalClose}
        customerInfo={{
          displayId: createCustomerDisplayId(),
          name: "",
          phone: phoneBuffer,
          addressLine: "Sharjah",
          city: "sharjah",
          country: "UAE",
          trn: ""
        }}
      /> : null }
    </React.Fragment>
  )
};

export default CustomerDueDate;